let plt: number | undefined;

export function setPlt(value: number | undefined) {
    plt = value;
}

export function getPlt() {
    return plt;
}
